import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MeetingService } from 'src/app/service/meeting.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { environment } from 'src/environments/environment';
import { PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-link-notetotask-dialog',
  templateUrl: './link-notetotask-dialog.component.html',
  styleUrls: ['./link-notetotask-dialog.component.css']
})
export class LinkNotetotaskDialogComponent implements OnInit {

  minutesInfo: any;
  meetingInfoData:any;
  minAttrList: any;

  taskAssign: any[] = [];
  notesAssign: any[] = [];
  taskList :any[] =[]; // available tasks to link
  notesList :any[] =[]; // available tasks to link

  selectedTasksList: any[] = []; 
  selectedNotesList: any[] = [];// already linked tasks
  linkedTasks: any[] = []; // full linked task info
  agendas: any = {};
  linkedTaskIds: string[] = [];
  linkedNoteIds: string[] = [];
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource<any>();
  dataSource2 = new MatTableDataSource<any>();
linkedDataSources: { [agendaId: string]: MatTableDataSource<any> } = {};
  @ViewChildren(MatPaginator) linkedPaginators!: QueryList<MatPaginator>;
  dataSources: { [agendaId: string]: MatTableDataSource<any> } = {};
@ViewChildren(MatPaginator) paginators!: QueryList<MatPaginator>;
@ViewChildren('linkedTaskPaginator') linkedTaskPaginators!: QueryList<MatPaginator>;
@ViewChildren(MatSort) sorts!: QueryList<MatSort>;
  displayedColumns = ['select', 'taskTitle', 'createdByName', 'assignedTo', 'dueDateStr', 'status'];
  linkedDisplayedColumns = ['select', 'taskTitle', 'createdByName', 'assignedTo', 'dueDateStr', 'status'];
  taskObj: any;
  filteredAgendas: any[] = [];
  type: any;
  meetingTitle: void;
  assignedTo: any;
  FollowupTask: any;
  actionItemOwner: any;
  pagedLinkedItemsMap: { [agendaId: number]: any[] } = {}; // for Linked tab
pagedLinkItemsMap: { [agendaId: number]: any[] } = {};   // for Link tab

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public meetingService: MeetingService,
    public dialogRef: MatDialogRef<LinkNotetotaskDialogComponent>
    
  ) {
    this.minutesInfo = data.meetingRes || {};
    this.minAttrList = data.noteRes || {};
    this.assignedTo = data.assignedTo;
    

        this.agendas = data.agendas ||[];
    this.FollowupTask =data.FollowupTask||[];
    this.meetingTitle = data.meetingTitle
    
    
    this.type=data.type
  }

  ngOnInit(): void {
    
    
    
    // Filter agendas that are not follow-up
    this.filteredAgendas = Array.isArray(this.agendas)
      ? this.agendas.filter(a => a.agendaFollowupFlag !== 'Y')
      : [];
  
    // Initialize tasks
    this.linkedTaskIds = this.minAttrList.linkedTaskIds || [];
    this.linkedNoteIds = this.minAttrList.linkedNoteIds || [];


    
    this.initializeTasks();
    if (this.type === 'TASK') {
      this.displayedColumns = ['select', 'noteDescription'];
    } else {
      this.displayedColumns = ['select', 'taskTitle', 'createdByName', 'assignedTo', 'dueDateStr', 'status'];
    }
  }
  
  initializeTasks(){
    
    if (!Array.isArray(this.minutesInfo)) {
      return;
    }
  
    // Reset
    this.dataSources = {};
    this.linkedDataSources = {};
  
    if (this.type === "TASK") {
      // Populate notes
      this.notesList = this.minutesInfo.map((note: any) => ({
        ...note,
        agendaId: note.agendaId || 0
      }));
  
      // Split assignable vs linked notes
      this.notesAssign = this.notesList.filter(
        note => !this.linkedNoteIds.includes(note.noteId)
      );
      

      this.selectedNotesList = this.notesList.filter(
        note => this.linkedNoteIds.includes(note.noteId)
      );
      

      // Create dataSources per agenda
      this.filteredAgendas.forEach((agenda: any) => {
        const agendaNotes = this.notesAssign.filter(n => n.agendaId === agenda.agendaId);
        this.dataSources[agenda.agendaId] = new MatTableDataSource<any>(agendaNotes);
  
        const linkedNotes = this.selectedNotesList.filter(n => n.agendaId === agenda.agendaId);
        this.linkedDataSources[agenda.agendaId] = new MatTableDataSource<any>(linkedNotes);
      });
    } else if (this.type === "NOTE") {
      // Populate tasks
      this.taskList = this.minutesInfo.map((task: any) => ({
        ...task,
        agendaId: task.agendaId || 0
      }));
      

      // Split assignable vs linked tasks
      this.taskAssign = this.taskList.filter(
        task => !this.linkedTaskIds.includes(task.taskId)
      );
      

      this.selectedTasksList = this.taskList.filter(
        task => this.linkedTaskIds.includes(task.taskId)
      );
      

      // Create dataSources per agenda
      this.filteredAgendas.forEach((agenda: any) => {
        const agendaTasks = this.taskAssign.filter(t => t.agendaId === agenda.agendaId);
        this.dataSources[agenda.agendaId] = new MatTableDataSource<any>(agendaTasks);
        
        const linkedTasks = this.selectedTasksList.filter(t => t.agendaId === agenda.agendaId);
        this.linkedDataSources[agenda.agendaId] = new MatTableDataSource<any>(linkedTasks);
      });
    }
    this.filteredAgendas.forEach((agenda: any) => {
      this.initializePagination(agenda.agendaId);
    });
     

  }
  pagedItemsMap: { [agendaId: number]: any[] } = {};
  pagedItemsMapAll: { [agendaId: number]: any[] } = {}; // for getItemsByAgendaId

// Call this whenever you initialize dataSources
initializePagination(agendaId: number): void {
  const allItems = this.getSelectedItemsByAgendaId(agendaId).data;
  this.pagedItemsMap[agendaId] = allItems.slice(0, this.pageSize);
}
initializePaginationAll(agendaId: number): void {
  const allItems = this.getItemsByAgendaId(agendaId).data;
  this.pagedItemsMapAll[agendaId] = allItems.slice(0, this.pageSize);
}

  isMinutesExist(agenda:any){
    if (this.type === "NOTE") {
      return this.taskList.some(t => t.agendaId === agenda.agendaId);
    } else if (this.type === "TASK") {
      return this.notesList.some(n => n.agendaId === agenda.agendaId);
    }
    return false;
  }

masterToggle(agendaId: number, type: 'selected' | 'all') {
    const rows = type === 'selected'
      ? this.pagedItemsMap[agendaId] || []
      : this.pagedLinkItemsMap[agendaId] || this.getItemsByAgendaId(agendaId).data;
  
    if (this.isAllSelected(agendaId, type)) {
      rows.forEach(row => this.selection.deselect(row));
    } else {
      rows.forEach(row => this.selection.select(row));
    }
  }
  
  isAllSelected(agendaId: number, type: 'selected' | 'all'): boolean {
    const rows = type === 'selected'
      ? this.pagedItemsMap[agendaId] || []
      : this.pagedLinkItemsMap[agendaId] || this.getItemsByAgendaId(agendaId).data;
  
    return rows.length > 0 && rows.every(row => this.selection.isSelected(row));
  }

  toggleSelection(row: any): void {
    this.selection.toggle(row);
    
  }

  onSave(): void {
    const selectedItems = this.selection.selected;
  
    if (this.type === "NOTE") {
      const taskIds = selectedItems.map(task => task.taskId);
      const previouslyLinked = this.minAttrList.linkedTaskIds || [];
      const merged = Array.from(new Set([...previouslyLinked, ...taskIds]));
  
      this.linkedTaskIds = merged;
      this.minAttrList.linkedTaskIds = merged;
  
      this.meetingService.linkTasksToNote(this.minAttrList.noteId, this.minAttrList).subscribe({
        next: () => {
          taskIds.forEach(id => {
            const task = this.taskAssign.find(t => t.taskId === id);
            if (task) this.selectedTasksList.push(task);
          });
  
          this.taskAssign = this.taskAssign.filter(t => !taskIds.includes(t.taskId));
  
          Object.keys(this.dataSources).forEach(agendaId => {
            const tasksForAgenda = this.taskAssign.filter(t => t.agendaId === +agendaId);
            this.dataSources[agendaId].data = tasksForAgenda;
            this.dataSources[agendaId]._updateChangeSubscription();
  
            //  Re-run pagination for updated data
            this.initializePagination(+agendaId);
          });
  
          this.selection.clear();
        },
        error: (err) => console.error("Error linking tasks to note:", err)
      });
  
    } else if (this.type === "TASK") {
      const noteIds = selectedItems.map(note => note.noteId);
      const previouslyLinked = this.minAttrList.linkedNoteIds || [];
      const merged = Array.from(new Set([...previouslyLinked, ...noteIds]));
  
      this.linkedNoteIds = merged;
      this.minAttrList.linkedNoteIds = merged;
      this.minAttrList.taskEntityType = environment.taskEntityType;
      this.minAttrList.taskEditFrom = 'MT';
  
      this.meetingService.linkNotesToTask(this.minAttrList.taskId, this.minAttrList).subscribe({
        next: () => {
          noteIds.forEach(id => {
            const note = this.notesAssign.find(n => n.noteId === id);
            if (note) this.selectedNotesList.push(note);
          });
  
          this.notesAssign = this.notesAssign.filter(n => !noteIds.includes(n.noteId));
  
          Object.keys(this.dataSources).forEach(agendaId => {
            const notesForAgenda = this.notesAssign.filter(n => n.agendaId === +agendaId);
            this.dataSources[agendaId].data = notesForAgenda;
            this.dataSources[agendaId]._updateChangeSubscription();
  
            //  Re-run pagination for updated data
            this.initializePagination(+agendaId);
          });
  
          this.selection.clear();
        },
        error: (err) => console.error("Error linking notes to task:", err)
      });
    }
  }

  onRemoveLinkedItems() {
    const selectedToRemove = this.selection.selected;
  
    if (!selectedToRemove.length) return;
  
    if (this.type === "NOTE") {
      // Update linkedTaskIds
      this.linkedTaskIds = this.linkedTaskIds.filter(taskId =>
        !selectedToRemove.some(task => task.taskId === taskId)
      );
      this.minAttrList.linkedTaskIds = this.linkedTaskIds;
  
      // Move back to assignable list
      selectedToRemove.forEach(task => this.taskAssign.push(task));
  
      // Remove from linked list
      this.selectedTasksList = this.selectedTasksList.filter(
        task => !selectedToRemove.some(t => t.taskId === task.taskId)
      );
  
      // Refresh all agenda datasources
      Object.keys(this.dataSources).forEach(agendaId => {
        this.dataSources[+agendaId].data = this.taskAssign.filter(t => t.agendaId === +agendaId);
        this.dataSources[+agendaId]._updateChangeSubscription();
  
        this.initializePagination(+agendaId);
      });
  
      Object.keys(this.linkedDataSources).forEach(agendaId => {
        this.linkedDataSources[+agendaId].data = this.selectedTasksList.filter(t => t.agendaId === +agendaId);
        this.linkedDataSources[+agendaId]._updateChangeSubscription();
  
        this.initializePagination(+agendaId);
      });
  
      this.selection.clear();
  
      // Call backend
      this.meetingService.linkTasksToNote(this.minAttrList.noteId, this.minAttrList).subscribe({
        next: res => console.log("Unlink tasks successful:", res),
        error: err => console.error("Error unlinking tasks from note:", err)
      });
  
    } else if (this.type === "TASK") {
      // Update linkedNoteIds
      this.linkedNoteIds = this.linkedNoteIds.filter(noteId =>
        !selectedToRemove.some(note => note.noteId === noteId)
      );
      this.minAttrList.linkedNoteIds = this.linkedNoteIds;
      
  
      // Move back to assignable list
      selectedToRemove.forEach(note => this.notesAssign.push(note));
  
      // Remove from linked list
      this.selectedNotesList = this.selectedNotesList.filter(
        note => !selectedToRemove.some(n => n.noteId === note.noteId)
      );
  
      // Refresh all agenda datasources
      Object.keys(this.dataSources).forEach(agendaId => {
        this.dataSources[+agendaId].data = this.notesAssign.filter(n => n.agendaId === +agendaId);
        this.dataSources[+agendaId]._updateChangeSubscription();
  
        this.initializePagination(+agendaId);
      });
  
      Object.keys(this.linkedDataSources).forEach(agendaId => {
        this.linkedDataSources[+agendaId].data = this.selectedNotesList.filter(n => n.agendaId === +agendaId);
        this.linkedDataSources[+agendaId]._updateChangeSubscription();
  
        this.initializePagination(+agendaId);
      });
  
      this.selection.clear();
      this.minAttrList.taskEntityType = environment.taskEntityType;
      this.minAttrList.taskEditFrom = 'MT';
  
      // Call backend
      this.meetingService.linkNotesToTask(this.minAttrList.taskId, this.minAttrList).subscribe({
        next: res => console.log("Unlink notes successful:", res),
        error: err => console.error("Error unlinking notes from task:", err)
      });
    }
  }
  
  
  
  

  onCancel(): void {
    this.dialogRef.close();
  }

  getItemsByAgendaId(agendaId: number): MatTableDataSource<any> {
    // Choose the assignable list and datasource based on type
    const assignableList = this.type === 'NOTE' ? this.taskAssign : this.notesAssign;
    const dataSourcesObj = this.type === 'NOTE' ? this.dataSources : this.dataSources;
  
    if (!dataSourcesObj[agendaId]) {
      const items = assignableList.filter(item => item.agendaId === agendaId) || [];
      dataSourcesObj[agendaId] = new MatTableDataSource(items);
    }
    return dataSourcesObj[agendaId];
  }
  
  getSelectedItemsByAgendaId(agendaId: number): MatTableDataSource<any> {
    // Choose the linked list and linked datasource based on type
    const selectedList = this.type === 'NOTE' ? this.selectedTasksList : this.selectedNotesList;
    const linkedObj = this.type === 'NOTE' ? this.linkedDataSources : this.linkedDataSources;
  
    if (!linkedObj[agendaId]) {
      const items = selectedList.filter(item => item.agendaId === agendaId);
      linkedObj[agendaId] = new MatTableDataSource(items);
  
      // Attach paginator & sort if needed
      const paginator = this.linkedPaginators?.toArray()[Object.keys(linkedObj).length - 1];
      if (paginator) linkedObj[agendaId].paginator = paginator;
  
      const sort = this.sorts?.toArray()[Object.keys(linkedObj).length - 1];
      if (sort) linkedObj[agendaId].sort = sort;
    } else {
      linkedObj[agendaId].data = selectedList.filter(item => item.agendaId === agendaId);
    }
  
    return linkedObj[agendaId];
  }
  
  ngAfterViewInit(): void {
    
    const paginatorArray = this.paginators.toArray();
    const sortArray = this.sorts.toArray();
  
    const agendaIds = Object.keys(this.dataSources);
    // Attach paginators for linked data sources as well
    const linkedPaginatorArray = this.linkedTaskPaginators.toArray();
  
    Object.keys(this.linkedDataSources).forEach((agendaId, index) => {
      const linkedSource = this.linkedDataSources[agendaId];
      if (linkedPaginatorArray[index]) linkedSource.paginator = linkedPaginatorArray[index];
      linkedSource._updateChangeSubscription();
    });
  }
 
  selectedTabIndex = 0;

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
  
    if (this.selectedTabIndex === 1) { // Assuming index 1 is your linked tab
      Object.keys(this.linkedDataSources).forEach(agendaId => {
        this.initializePagination(+agendaId); // Load first page of linked tab data
      });
    }
  }
  
pageSize = 10;
pageIndex = 0;
pagedItems: any[] = [];

onPageChange(event: PageEvent, agendaId: number, source: 'selected' | 'all' = 'selected'): void {
  this.pageSize = event.pageSize;
  this.pageIndex = event.pageIndex;

  let allItems;
  if (source === 'selected') {
    allItems = this.getSelectedItemsByAgendaId(agendaId).data;
    this.pagedItemsMap[agendaId] = allItems.slice(
      this.pageIndex * this.pageSize,
      this.pageIndex * this.pageSize + this.pageSize
    );
  } else {
    allItems = this.getItemsByAgendaId(agendaId).data;
    this.pagedItemsMapAll[agendaId] = allItems.slice(
      this.pageIndex * this.pageSize,
      this.pageIndex * this.pageSize + this.pageSize
    );
  }
}






}
